module.exports = __webpack_public_path__ + "static/media/Dragonborn.28fcc1ba.png";